import React from 'react';
import LongText from '../../Elements/LongText';
import FieldTypesEnum from '../../Enums/FieldTypesEnum';
import JsxHelper from '../../Helpers/JsxHelper';
import DataTableActionMenu from '../../Elements/DataTable/DataTableActionMenu';
import RedirectLinkComponent from '../../Elements/RedirectLinkComponent';
import GroupNameComponent from '../../Elements/GroupNameComponent';

export default class GroupMemberItem
{
  constructor (item)
  {
    if (item === undefined)
    {
      this.UserId = '';
      this.OfficeId = '';
      this.UserName = '';
      this.FirstName = '';
      this.LastName = '';
      this.Name = '';
      this.Email = '';
      this.GroupId = '';

      this.Selected = false;
      return;
    }

    this.UserId = item.userId;
    this.OfficeId = item.officeId;
    this.UserName = item.userName;
    this.FirstName = item.firstName;
    this.LastName = item.lastName;
    this.Name = `${item.firstName}, ${item.lastName}`;
    this.Description = item.description;
    this.Email = item.email;
    this.GroupId = item.groupId;

    this.Selected = false;
  }

  static displayedInList = 'Name';

  static NameOfTheIdField ()
  {
    return 'UserId';
  }

  static MoneyFields = [];

  static Currency ()
  {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary ()
  {
    return '';
  }

  static DateOnlyFields = [];

  static DateFields = [];

  static BoolFields = [];

  static nameOfTheItemDetailList (item)
  {
    if (item)
      return (
        <span>
          Group Details -{' '}
          <LongText
            text={`${item.Name} (${item.UserId})`}
            maxLength={40}
          />
        </span>
      );
    return 'Group Member Details';
  }

  static idFunction (item)
  {
    return (
      <RedirectLinkComponent
        isFigmaStyle={true}
        path='home_users'
        tooltipText={item.UserId}
        text={item.UserId}
        keyValuePairs={[ { key: 'Id', value: item.UserId } ]}
      />
    );
  }
  static getSelectedCellHeader ()
  {
    return (
      <input
        type='checkbox'
        checked={GroupMemberItem.selectedStatus()}
        onChange={(e) =>
        {
          GroupMemberItem.clickOnGlobalSelect(e.target.checked);
        }}
      />
    );
  }

  static clickOnSelect (item)
  {
    alert('Click');
  }

  static selectedStatus ()
  {
    return false;
  }

  static clickOnGlobalSelect (item, selected) { }

  static getSelectedCellContent (item)
  {
    if (item.Selected === undefined) item.Selected = false;
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onClick={(e) =>
          {
            GroupMemberItem.clickOnSelect(item);
          }}
          onChange={(e) => { }} //Don't remove. This is necessary to eliminate the React warning!
        />
      </div>
    );
  }

  static FieldsToShowInDataTable ()
  {
    return [
      {
        label: GroupMemberItem.getSelectedCellHeader,
        orderById: '',
        data: GroupMemberItem.getSelectedCellContent,
      },
      {
        label: 'User ID',
        orderById: 'UserId',
        data: GroupMemberItem.idFunction,
        type: FieldTypesEnum.PureDataField,
      },
      { label: 'Name', orderById: 'Name', data: 'Name' },
      { label: 'Username', orderById: 'UserName', data: 'UserName' },
      { label: 'Email', orderById: 'Email', data: 'Email' },
      {
        label: 'Member of Child Group',
        orderById: 'GroupId',
        data: (item) => GroupMemberItem.getGroupNameCellById(item.GroupId),
      },
      {
        label: ' ',
        orderById: 'UserId',
        data: GroupMemberItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static getGroupNameCellById (id)
  {
    if (!id) return '';
    return <GroupNameComponent groupId={id} />;
  }

  static removeFunction = (item, itemList) =>
  {
    alert('Empty function');
  };

  static getActionsContent (item)
  {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-regular fa-trash-can',
            text: 'Remove Membership',
            onClick: () => GroupMemberItem.removeFunction(item),
            roleKey: 'group_edit',
            disabled: item.GroupId, // Disable if the member is part of a child group, not directly the current group
          },
        ]}
      />
    );
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'GroupId', label: 'Group ID' },
        { name: 'Name', label: 'Name' },
        { name: 'Description', label: 'Description' },
      ],
    },
  ];
}
